export const DocumentRepo = "DocumentRepo/";
export const AddOrEditDocumentSection = DocumentRepo + "AddOrEditDocumentSection";
export const Search = DocumentRepo + "Search";
export const DeleteDocumentSection = DocumentRepo + "DeleteDocumentSection";
export const InsertDocumentSectionItem = DocumentRepo + "InsertDocumentSectionItem";
export const DeleteDocumentItem = DocumentRepo + "DeleteDocumentItem";